<template>
  <div class="page_container content-box">
     <ToolsList />
  </div>
</template>

<script>
import ToolsList from "./ToolsList.vue"

export default {
    components:{
        ToolsList,
    },
}
</script>



<style scoped lang="scss">


</style>